<h1 mat-dialog-title class="dialog-title">Create units</h1>

<div mat-dialog-content class="dialog-content" [formGroup]="unitCountForm">
  <p class="dialog-description">
    Enter the number of units to create for this multifamily property. The primary structure will be updated to match.
  </p>

  <profet-input
    formControlName="unitCount"
    label="Number of Units"
    type="number"
    placeholder="e.g. 8"
    [required]="true"
    [minValue]="minUnitCount"
    [maxValue]="maxUnitCount"
  />
</div>

<div mat-dialog-actions class="dialog-footer">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button type="button" color="accent" [disabled]="unitCountForm.invalid" (click)="createUnits()">
    Create Units
  </button>
</div>
